export const ocrStartupMessages = {
  'zh-CN': {
    startingEngine: '正在启动识别引擎',
    windowSelectedStage: '游戏窗口已选择',
    timeoutTitle: '识别引擎启动超时',
    timeoutHint: '识别引擎启动超时，请重新启动；已选择的窗口将保留。',
    sdkTimeoutHint: '识别程序加载超时。请重新启动；如果仍然失败，请刷新页面后重新选择窗口。',
    retryEngine: '重新启动',
    copyDiagnostic: '复制诊断信息',
    diagnosticCopied: '诊断信息已复制',
    diagnosticCopyFailed: '自动复制失败，请手动复制下方诊断信息。',
    diagnosticLabel: '启动诊断信息',
  },
  en: {
    startingEngine: 'Starting the recognition engine',
    windowSelectedStage: 'Game window selected',
    timeoutTitle: 'Recognition engine startup timed out',
    timeoutHint: 'Recognition engine startup timed out. Try starting again; your selected window is retained.',
    sdkTimeoutHint: 'The recognition program took too long to load. Try starting again. If it still fails, reload the page and select your window again.',
    retryEngine: 'Restart',
    copyDiagnostic: 'Copy diagnostics',
    diagnosticCopied: 'Diagnostics copied',
    diagnosticCopyFailed: 'Automatic copying failed. Copy the diagnostics below manually.',
    diagnosticLabel: 'Startup diagnostics',
  },
}
